function footerAccordion() {
  if (window.matchMedia('(min-width: 750px)').matches) {
    return
  }
  const handleCollapse = (heading) => {
    if (heading.classList.contains('block-collapsed')) {
      heading.classList.remove('block-collapsed')
      heading.setAttribute('aria-expanded', 'true')
    } else {
      heading.classList.add('block-collapsed')
      heading.setAttribute('aria-expanded', 'false')
    }
  }
  document.querySelectorAll('.grid .footer-block__heading').forEach((heading, index) => {
    heading.classList.add('block-collapsed')
    heading.setAttribute('role', 'button')
    heading.setAttribute('aria-expanded', 'false')
    heading.setAttribute('tabindex', '0')

    heading.nextElementSibling.setAttribute('id', 'footer-block-index-${index}')
    heading.setAttribute('aria-controls', 'footer-block-index-${index}')

    heading.addEventListener('click', () => { handleCollapse(heading) })
    heading.addEventListener('keypress', () => { handleCollapse(heading) })
  })
}

window.addEventListener('DOMContentLoaded', (event) => {
  window.dispatchEvent(new Event('resize'));
  footerAccordion()
});

document.addEventListener("shopify:section:load", function(event) {
  window.dispatchEvent(new Event('resize'));
  footerAccordion()
});

